import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // <-- import useNavigate

const ResetPasswordAgent = () => {
  const { token } = useParams();
  const navigate = useNavigate(); // <-- initialisation

  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(
      `https://keurgui-backend-kjour.ondigitalocean.app/api/reset-password-agent/${token}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      }
    );

    const data = await res.json();
    setMessage(data.message);

    // ✅ Redirection après succès
    if (res.ok) {
      // petite pause pour afficher le message
      setTimeout(() => {
        navigate("/loginagent");
      }, 1500); // 1,5 seconde avant la redirection
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h4>Nouveau mot de passe</h4>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Changer le mot de passe</button>
        </form>

        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default ResetPasswordAgent;